import React from 'react';

const SubWorks = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Works</h1>
      <p>THAT'S HOW YOU GET IT.</p>
    </section>
  );
};

export default SubWorks;
